export const getCommonPages = (userInfo) => {
  const pages = ['Project List'];

  if (userInfo?.isInternal) {
    pages.push('Create Project');
  }

  return pages;
};

// const IdentifierNameMap = {
//   complexity: 'Project Home - Deal Complexity',
//   navigator: 'Project Home - Integration Navigator',
//   lifecycleDivestitures: 'Project Home - M&A Lifecycle',
//   lifecycle: 'Project Home - M&A Lifecycle',
// };
const SectionTypeNameMap = {
  powerbi: 'Project Home - PowerBI',
  image: 'Project Home - Image',
  pdf: 'Project Home - PDF',
  textContainer: 'Project Home - Text',
  chart: 'Project Home - Visualization Widget',
  text: 'Project Home - Other',
  other: 'Project Home - Other',
  M365: 'Project Home - M365',
};

export const getProjectHomeSections = (
  projectStatusData,
  accessibleModules,
) => {
  const homepageSectionIdentifiers =
    accessibleModules?.homepageSectionList || [];
  const moduleOrderAndFlag = projectStatusData?.moduleOrderAndFlag || [];
  const sections = moduleOrderAndFlag
    .filter((section) =>
      homepageSectionIdentifiers.includes(section.identifier),
    )
    .map((section) =>
      section.type === 'default' || !section.type
        ? `Project Home - ${section?.titleName}`
        : SectionTypeNameMap[section.type],
    )
    .filter((i) => Boolean(i));

  return Array.from(new Set(sections));
};

export const getQuestionnairePages = (
  questionnaireStatus,
  customizeModule = [],
  moduleIdentifierList,
) => {
  const pages = [];
  const questionnaireModule = customizeModule.find(
    (i) => i.value === 'questionnaire',
  );
  if (questionnaireModule && moduleIdentifierList.includes('complexity')) {
    if (questionnaireModule.module) {
      pages.push(questionnaireModule.module);
    }
    if (questionnaireStatus?.status >= 1) {
      pages.push(...['Review Response', 'Deal Complexity']);
    }
  }

  return pages;
};

// export const getAnalysisAndInsightPages = (
//   customizeModule = [],
//   accessibleModules,
// ) => {
//   const moduleIdentifierList = accessibleModules?.moduleList || [];
//   const analysisModule = customizeModule.find((i) =>
//     ['analysis'].includes(i.value),
//   );
//   const analysisSubmodules =
//     analysisModule?.originPermissions
//       ?.filter((i) => moduleIdentifierList.includes(i.value))
//       .map((i) => `${analysisModule?.module} - ${i.label}`) || [];
//
//   const insightModule = customizeModule.find((i) =>
//     ['insight'].includes(i.value),
//   );
//   const insightsModules =
//     insightModule?.originPermissions
//       ?.filter((i) => moduleIdentifierList.includes(i.value))
//       .map((i) => `${insightModule?.module} - ${i.label}`) || [];
//   return [...analysisSubmodules, ...insightsModules];
// };

export const getAnalysisAndInsightPages = (
  moduleName,
  originPermissions = [],
  moduleIdentifierList,
) =>
  originPermissions
    ?.filter((i) => moduleIdentifierList.includes(i.value))
    .map((i) => `${moduleName} - ${i.label}`);

const ModuleTypeNameMap = {
  imageModule: 'Customized Module - Image',
  powerbiModule: 'Customized Module - PowerBI',
  regular: 'Customized Module - Other',
  M365: 'Customized Module - M365',
  textContainer: 'Customized Module - Text',
  widget: 'Customized Module - Visualization Widget',
  multiSection: 'Customized Module - Multi-section',
  pdf: 'Customized Module - PDF',
  html: 'Customized Module - HTML',
};
export const getCustomizedModulesPages = (
  customizeModule = [],
  accessibleModules,
) => {
  const moduleIdentifierList = accessibleModules?.moduleList || [];

  const pages =
    customizeModule
      .filter(
        (i) => i.type !== 'default' && moduleIdentifierList.includes(i.value),
      )
      .map((i) => ModuleTypeNameMap[i.type])
      .filter(Boolean) || [];

  return Array.from(new Set(pages));
};

const isCustomizedModule = (i) =>
  typeof i === 'string' && i.startsWith('Customized Module');
const isNotCustomizedModule = (i) =>
  typeof i === 'string' && !i.startsWith('Customized Module');

export const getModuleNames = (
  customizeModule = [],
  accessibleModules,
  questionnaireStatus,
) => {
  const moduleIdentifierList = accessibleModules?.moduleList || [];
  let result = [];
  customizeModule.forEach((item) => {
    if (['analysis', 'insight'].includes(item.value)) {
      result.push(
        ...getAnalysisAndInsightPages(
          item.module,
          item.originPermissions,
          moduleIdentifierList,
        ),
      );
    } else if (item.value === 'questionnaire') {
      result.push(
        ...getQuestionnairePages(
          questionnaireStatus,
          customizeModule,
          moduleIdentifierList,
        ),
      );
    } else if (
      item.type !== 'default' &&
      moduleIdentifierList.includes(item.value)
    ) {
      const moduleLabel = ModuleTypeNameMap[item.type];
      if (moduleLabel) {
        result.push(moduleLabel);
      }
    }
  });
  result = result.filter(Boolean);
  const firstCustomizedModuleIndex = result.findIndex(isCustomizedModule);
  if (firstCustomizedModuleIndex !== -1) {
    const pureCustomizedModule = result.filter(isCustomizedModule);
    const restModules = result.filter(isNotCustomizedModule);
    restModules.splice(firstCustomizedModuleIndex, 0, ...pureCustomizedModule);

    result = restModules;
  }
  result = Array.from(new Set(result));

  return result;
};
